'use client';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import ShareModal from '@/components/modals/share-modal';
import { FiUpload } from 'react-icons/fi';
import { event_button_click } from '@/utils/gtm';

const ShareButton = ({ title, description }) => {
  const t = useTranslations('common');
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({ canonical: '', url: '' });
  const shareDetails = { url: config.url, title, description };

  useEffect(() => {
    const canonical = document.querySelector('link[rel=canonocal]');
    const url = canonical ? canonical.href : document.location.href;
    setConfig({
      canonical,
      url,
    });
  }, []);

  const handleShare = async () => {
    event_button_click({
      button_name: 'Share',
      button_destination: 'open_share',
      button_location: 'pdp',
    });
    if (navigator.share) {
      try {
        navigator.share(shareDetails);
      } catch (error) {
        console.log(`Oops! I couldn't share to the world because: ${error}`);
      }
    } else {
      setOpen(true);
    }
  };
  return (
    <>
      <button
        onClick={handleShare}
        title='Share'
        aria-label={t('share')}
        className='flex size-10 items-center justify-center rounded-full bg-white/80 p-1 shadow-md transition-colors hover:bg-white lg:bg-white/90 lg:p-2'
      >
        <FiUpload className='text-gray-600' />
      </button>
      <ShareModal {...{ url: config.url, title, t, open, setOpen }} />
    </>
  );
};

export default ShareButton;
